import {ValidationError} from "yup";

export const handleError = (toast, t, error) => {
    if (error instanceof ValidationError) {
        let messages = error.errors.map((err) => ({
            severity: "error",
            summary: t("common:error"),
            detail: t(err),
            life: 3000,
        }));
        toast.current.show(messages);
    } else if (error?.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        if (error.response.data) {
            let data = error.response.data;
            if (data.detail) {
                if (Array.isArray(data.detail)) {
                    let messages = data.detail.map((obj) => {
                        let key = Object.keys(obj)[0];
                        let value = obj[key];
                        return {
                            severity: "error",
                            summary: t("common:error"),
                            detail: `${t(key)}: ${value}`,
                            life: 3000
                        }
                    });

                    toast.current.show(messages);
                } else if (typeof data.detail === "object") {
                    let key = Object.keys(data.detail)[0];
                    let value = data.detail[key];
                    let message = `${t(key)}: ${value}`;
                    toast.current.show({severity: "error", summary: t("common:error"), detail: message, life: 30000});
                } else {
                    let message = data.detail;
                    toast.current.show({severity: "error", summary: t("common:error"), detail: message, life: 30000});
                }
            } else {
                let message = data.message ? data.message : data.error;
                toast.current.show({severity: "error", summary: t("common:error"), detail: message, life: 30000});
            }
        } else if (error.response.status === 401) {
            window.location.reload();
            //toast.current.show({severity: "error", summary: t("common:error"), detail: "Unauthorized", life: 3000});
        }
    } else if (error?.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        toast.current.show({severity: "error", summary: t("common:error"), detail: "Request Error", life: 30000});
    } else {
        // Something happened in setting up the request that triggered an Error
        const message = error?.message
        toast.current.show({severity: "error", summary: t("common:error"), detail: message, life: 30000});
    }
};
